module.exports = __webpack_public_path__ + "b6164fa2c545bc0b562595659ad8e5c2.svg";